import { relationSchema } from "./relation";
import { z } from "zod";

export const projectStatusEnum = z.enum(["active", "done"]);

const baseProjectSchema = z.object({
  title: z.string({ invalid_type_error: "Title must be a string" }).min(1, { message: "Title cannot be empty" }),
  description: z.string({ invalid_type_error: "Description must be a string" }).optional().nullable(),
  startDate: z.date({ invalid_type_error: "Start date must be a valid date" }).optional().nullable(),
  endDate: z.date({ invalid_type_error: "End date must be a valid date" }).optional().nullable(),
  status: projectStatusEnum,
  relationId: z.string().min(1, { message: "Relation is required" }),
});

export const createProjectSchema = baseProjectSchema;

export const updateProjectSchema = baseProjectSchema.partial().extend({
  id: z.string({ invalid_type_error: "ID must be a string" }),
});

export const getProjectSchema = z.object({
  id: z.string({ invalid_type_error: "ID must be a string" }),
});

export const deleteProjectSchema = z.object({
  id: z.string({ invalid_type_error: "ID must be a string" }),
});

export const getProjectsParamsSchema = z.object({
  relationId: z.string().optional(),
});

export type ZodCreateProjectSchema = z.infer<typeof createProjectSchema>;
export type ZodUpdateProjectSchema = z.infer<typeof updateProjectSchema>;
export type ZodGetProjectSchema = z.infer<typeof getProjectSchema>;
export type ZodDeleteProjectSchema = z.infer<typeof deleteProjectSchema>;
export type ProjectStatusType = z.infer<typeof projectStatusEnum>;
export type ZodGetProjectsParams = z.infer<typeof getProjectsParamsSchema>;

export const projectSchema = baseProjectSchema.extend({
  id: z.string(),
  relation: relationSchema.optional(),
  organizationId: z.string(),
  userId: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type ProjectSchema = z.infer<typeof projectSchema>;

export const createProjectSchemaDefaultValues: ZodCreateProjectSchema = {
  title: "",
  description: "",
  startDate: null,
  endDate: null,
  status: "active",
  relationId: "",
};
